<template>
	<textarea
		class="textarea-autosize"
		:placeholder="placeholder"
   		:value="modelValue"
		:id="id"
		:required="required"
		:readonly="readonly"
		:disabled="disabled"
		:style="{ 'min-height' : (Number.isInteger(minHeight) ? `${this.minHeight}px` : null), 'resize' : 'none' }"
		@input="onInput"
	></textarea>
</template>

<script>
export default {
	props : {
		maxHeight : {
			type : Number
		},
		minHeight : {
			type : Number
		},
		placeholder: {
			type: String
		},
		id: {
			type: String
		},
        modelValue: {},
		required: {
			type: Boolean,
			default: false
		},
		readonly: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
	},
	methods: {
		onInput(event) {
			this.resize(event);
			this.$emit('update:modelValue', event.target.value)
		},
		resize(event) {
			event.target.style.height = "auto";
			event.target.style.height = (Number.isInteger(this.maxHeight) && event.target.scrollHeight > this.maxHeight) ? `${this.maxHeight}px` : `${event.target.scrollHeight}px`;
		},
	},
	mounted() {
		if(this.$el.length) {
			this.$nextTick(() => {
				this.$el.setAttribute("style", "height", `${this.$el.scrollHeight}px`);
			});
		}
	},
};
</script>